import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SubscriptionTier, TIER_NAMES, TIER_COLORS, getTierFeatures } from '../../types/subscription';

interface TierBadgeProps {
  tier: SubscriptionTier;
  size?: 'small' | 'medium';
  showTooltip?: boolean;
}

const StyledChip = styled(Chip)<{ tiercolor: string }>(({ tiercolor }) => ({
  backgroundColor: tiercolor,
  color: '#FFFFFF',
  fontWeight: 600,
  fontSize: '0.75rem',
  letterSpacing: '0.02em',
  textTransform: 'uppercase',
  border: 'none',
  '&:hover': {
    backgroundColor: tiercolor,
    opacity: 0.9,
  },
}));

export const TierBadge: React.FC<TierBadgeProps> = ({
  tier,
  size = 'small',
  showTooltip = true,
}) => {
  // Handle undefined/invalid tier gracefully
  const validTier = tier && TIER_NAMES[tier] ? tier : 'free';
  const tierName = TIER_NAMES[validTier];
  const tierColor = TIER_COLORS[validTier];
  const features = getTierFeatures(validTier);

  const badge = (
    <StyledChip
      label={tierName}
      size={size}
      tiercolor={tierColor}
    />
  );

  if (!showTooltip) {
    return badge;
  }

  const tooltipContent = (
    <div>
      <div style={{ fontWeight: 600, marginBottom: '4px' }}>{tierName} Plan</div>
      <div style={{ fontSize: '0.75rem', opacity: 0.9 }}>
        • {features.products} Products
        <br />
        • {features.locations} Locations
        <br />
        • {features.monthlySales} Monthly Sales
        <br />
        • Support: {features.supportLevel}
      </div>
    </div>
  );

  return (
    <Tooltip title={tooltipContent} arrow placement="right">
      {badge}
    </Tooltip>
  );
};

export default TierBadge;
